import React, { FC } from 'react';
import { Form } from 'antd';
import { WrappedFormUtils } from 'antd/lib/form/Form';
import { Input } from '../../../system/components/Input';

interface Props {
  form: WrappedFormUtils;
  initialValue?: string;
}

export const InputNPINumber: FC<Props> = ({ form, initialValue }): JSX.Element => (
  <Form.Item label="NPI Number:">
    {form.getFieldDecorator('npiNumber', {
      initialValue,
      rules: [{ required: false }],
    })(<Input allowClear placeholder="NPI Number" />)}
  </Form.Item>
);
